import { createSelector } from 'reselect';

import { AppState } from '../../../../store/models/app-state';

const footerSettingsState = (state: AppState) => state.contentManagement.footerSettings;

export const footerSettingsRequestingSelector = createSelector(footerSettingsState, state => state.requesting);
export const footerLinksSelector = createSelector(footerSettingsState, state => {
    return state.links ? JSON.stringify(state.links, null, 2) : '';
});
